import AboutSubPage from "@/pages/about/components/AboutSubPage";

export default function CoreValuesPage() {
  return (
    <AboutSubPage
      heroImageSrc="https://net-basis.net/Bilder/netbasis-core-values-trust-partnership.webp"
      texts={{
        title: "Grundwerte",
        heroClaimLine1: "Mit Werten",
        heroClaimLine2: "zum Erfolg!",
        bottomClaim: "NetBasis International - drive to excellence with excellent drivers !",
      }}
      metaTitle="Unsere Grundwerte | NetBasis International"
      metaDescription="Respekt, Loyalität, Professionalität, Ausdauer und Vertrauen – die tragenden Säulen für den nachhaltigen Erfolg unserer Herstellerpartner."
      metaOgUrl="https://net-basis.net/de/ueber-uns/grundwerte"
    >
      <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
        <h1 className="font-semibold text-foreground-950 text-sm md:text-base">
          Respekt. Loyalität. Professionalität. Ausdauer. Vertrauen.
        </h1>
        <p>Das sind die tragenden Grundwerte, denen sich NetBasis International felsenfest verschrieben hat und die uns tagtäglich durch unsere Arbeit führen. Sie begleiten uns in unserem unermüdlichen Engagement für unsere Geschäftspartner und leiten uns maßgeblich in der Art und Weise, wie wir unsere operativen Aufgaben erfüllen.</p>
        <p>Es ist unser täglicher Anspruch an uns selbst, sowohl neuen Partnern nachhaltig zu beweisen, dass sie mit uns die absolut richtige Wahl getroffen haben, als auch bestehenden Partnern in gemeinsamen Projekten immer wieder aufs Neue zu zeigen, dass sie bei uns in den besten Händen und rundum gut aufgehoben sind.</p>
        <p>Ihr Erfolg ist uns Verpflichtung.</p>
      </div>
    </AboutSubPage>
  );
}